import customHeaders, { getSpace } from '../../common/headers';
import { useState, useEffect, useRef } from 'react';
import { Modal } from '../../components/Modal/Modal';
import { OlegRulesHttps } from '../../fetchUrls';
import { ModalEditingRules } from '../../components/Modal/ModalEditingRules/ModalEditingRules';
import { ModalRules } from '../../components/Modal/ModalRules/ModalRules';
import { ButtonBasic, TableBox } from '@lk-gtcom/ecomlab-components';
import { useDataTable } from '../../common/hooks';
import useGeneralStore from '../../store/general';
import { StepItem } from '../../components/StepItem/StepItem';
import { useShallow } from 'zustand/react/shallow';
import { useNavigate } from 'react-router-dom';
import { useResponseHandler } from '../../common/auth';
import './AccountNotifications.scss';

const AccountNotifications = ({
  setIsEditSpace,
  setIsModalCreatingNewSpace
}) => {
  const selectedSpace = useGeneralStore((state) => state.selectedSpace);
  const headers = { ...customHeaders, ...getSpace(selectedSpace) };
  const { handleTableResponse, handleRequestError } = useResponseHandler();
  const navigate = useNavigate();

  const { setPageValue1 } =
    useGeneralStore(
      useShallow((state) => ({
        setPageValue1: state.setPageValue1
      }))
    );
  const [active, setActive] = useState([]);
  const [disactive, setDisactive] = useState([]);
  const [isModalRules, setIsModalRules] = useState(false);
  const [showAddConnectionModal, setShowAddConnectionModal] = useState(false);
  const [isModalCreate, setIsModalCreate] = useState(false);
  const [ruleInfo, setRuleInfo] = useState({});

  const [isEdit, setIsEdit] = useState(false);
  const [rule_id, setRuleId] = useState(1);
  const [ruleName, setRuleName] = useState('');

  const [strategyInfo, setStrategyInfo] = useState({});
  const [strategyParams, setStrategyParams] = useState([]);
  const [strategyParamValue, setStrategyParamValue] = useState([]);
  const [currentStrategyId, setCurrentStrategyId] = useState(-1);

  const paginatorRef = useRef();
  const [setTable, tableProps, setTableFuncs] = useDataTable(
    paginatorRef.current?.setTotal,
    paginatorRef
  );
  const { setLoading } = setTableFuncs;
  const { total } = tableProps;

  const service_id = 1;

  const fetchTable = (params) => {
    let sort, filters;
    if (params) {
      [sort, filters] = params;
    }

    const url = `https://apps0.ecomru.ru:4420/api/v1/${service_id}/client_rule/table`;
    setLoading(true)

    const body = JSON.stringify({
      filters,
      page: paginatorRef.current?.page,
      limit: paginatorRef.current?.limit,
    });

    fetch(url, { body, method: 'POST', headers })
      .then(handleTableResponse)
      .then((json) => setTable(json))
      .catch(handleRequestError)
      .finally(() => setLoading(false));
  };

  const fetchStrategies = () => {
    const url = `${OlegRulesHttps}/api/v1/${service_id}/strategy/model/${rule_id}/list`;

    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then((json) => setDisactive(json?.map((el) => ({ ...el, status: false }))))
      .catch(handleRequestError);
  };

  const fetchClientStrategies = () => {
    const url = `${OlegRulesHttps}/api/v1/{service_id}/rule_attrs/client/${rule_id}`;

    fetch(url, { method: 'GET', headers })
      .then(handleTableResponse)
      .then((json) => setActive(json?.map((el) => ({ ...el, status: true }))))
      .catch(handleRequestError)
  };


  const onCreateClientStrategy = (id, status, edit = false) => {
    const url = `${OlegRulesHttps}/api/v1/${service_id}/strategy`;

    const body = JSON.stringify({
      id: +rule_id,
      client_rule_id: +rule_id,
      strategy_id: +currentStrategyId,
      is_active: true,
      attributes: Object.keys(strategyParamValue).map((el) => {
        return {
          attr_id: +el,
          value: { ...strategyParamValue[el] },
        };
      }),
    });

    fetch(url, { body, method: edit ? 'PUT' : 'POST', headers })
      .then(handleTableResponse)
      .then((json) => {
        fetchStrategies();
        fetchClientStrategies();
      })
      .catch((err) => {
        setStrategyParams([]);
        setStrategyInfo({
          name: 'Для этой стратегии нет параметров, она будет применена для всех товаров',
          status,
          id,
        });
        console.error(err);
      })
      .finally(() => setCurrentStrategyId(-1));
  };

  useEffect(() => {
    fetchTable();
    fetchStrategies();
    fetchClientStrategies();
  }, []);

  return (
    <>
      {isModalRules && 
        <ModalEditingRules
          setIsModal={(e) => setIsModalRules(e)}
          strategyParams={strategyParams}
          setStrategyParamValue={(e) => setStrategyParamValue(e)}
          strategyInfo={strategyInfo}
          setStrategyInfo={(e) => setStrategyInfo(e)}
          strategyParamValue={strategyParamValue}
          onSaveHandler={(e) => {
            isEdit
              ? onCreateClientStrategy(e, '', true)
              : onCreateClientStrategy(e);
          }}
          edit={isEdit}
        />
      }

      {showAddConnectionModal && 
        <Modal
          isSocialNetwork={true}
          setIsModalActive={setShowAddConnectionModal}
        />
      }

      {isModalCreate && 
        <ModalRules
          isEdit={isEdit}
          setIsEdit={(e) => setIsEdit(false)}
          isCreate={!isEdit}
          {...ruleInfo}
          rule_id={rule_id}
          setRuleIdPar={setRuleId}
          ruleName={ruleName}
          service_id={service_id}
          setRuleInfo={(e) => setRuleInfo(e)}
          setIsModal={setIsModalCreate}
          handleSaveSuccess={fetchTable}
          notification={true}
        />
      }

      <div className="account-notifications">
        <div className="account-notifications__header">
          <StepItem
            title='Добавьте платформы, куда должны приходить уведомления'
          />

          <div className="account-notifications__btn-group">
            <ButtonBasic
              green
              onClick={(e) => {
                setIsEdit(false);
                setIsModalCreate(true);
                setRuleInfo({});
              }}
              text={"+ Добавить правило"}
            />

            <ButtonBasic
              whiteGreen
              text="+ Добавить подключение"
              onClick={() => {
                navigate('/settings/space');
                setIsEditSpace(true)
                setPageValue1('settings')
                setIsModalCreatingNewSpace(true);
              }}
            />
          </div>
        </div>

        <TableBox
          {...tableProps}
          ref={paginatorRef}
          paginator={true}
          fetchCallback={fetchTable}
          statistic={[{ label: 'Правил', sum: total }]}
          onAction={(e) => {
            const id = e?.['Идентификатор правила'];
            const ruleName = e?.['Название правила'];
            setIsModalCreate(true);
            setIsEdit(true);
            setRuleId(id);
            setRuleName(ruleName);
            fetchStrategies();
            fetchClientStrategies();
          }}
        />
      </div>
    </>
  );
};

export { AccountNotifications };
